import { render, staticRenderFns } from "./PreviewCatalog.vue?vue&type=template&id=b4e8a7ba&scoped=true"
import script from "./PreviewCatalog.vue?vue&type=script&lang=js"
export * from "./PreviewCatalog.vue?vue&type=script&lang=js"
import style0 from "@/assets/scss/category/new_band.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./PreviewCatalog.vue?vue&type=style&index=1&id=b4e8a7ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e8a7ba",
  null
  
)

export default component.exports